import { AbstractConcealed } from '../../types/lux/ui'
// import { setCurrentSeer } from '../lib/proxify-state'

export default AbstractConcealed

/** @constructor @extends {AbstractConcealed} @suppress {checkTypes} */ function _Concealed() {}
AbstractConcealed.__implement(
  _Concealed.prototype = /** @type {!AbstractConcealed} */ ({
    conceal() {
      const {
        asIStateful: { setState },
        state: { concealed },
      } = this
      if (concealed) return
      setState({ concealed: true })
    },
    unconceal() {
      const {
        asIStateful: { setState },
        state: { concealed },
      } = this
      if (!concealed) return
      setState({ concealed: false })
    },
    paint() {
      const {asIStateful:{state:{concealed}},asIElemental:{element}} = this
      if (concealed) hideBrick(element)
      else showBrick(element)
    },
    // should state reactions happen in the paint method ???
    // maybe paint should be combinable
  }),
)

/**
 * @param {HTMLElement} brick
 */
export const hideBrick = (brick) => {
  if (!brick) return
  brick.style.setProperty('display', 'none', 'important')
}
/**
 * @param {HTMLElement} brick
 */
export const showBrick = (brick) => {
  if (!brick) return
  brick.style.display = ''
}
